import getConfig from 'next/config'

import ALPHA_CONFIG from './url/alpha.json'
import DEV_CONFIG from './url/dev.json'
import LOCAL_CONFIG from './url/local.json'
import REAL_CONFIG from './url/real.json'
import STAGE_CONFIG from './url/stage.json'
import TEST_CONFIG from './url/test.json'

import type {REAL_URL, Phase, SERVICE} from '@financial/service-origins'
import type {ValueOf} from 'next/constants'

type DisallowKeysInServiceOrigin<T, U> = Extract<keyof T, U> extends never ? T : never

// @financial/service-origins의 SERVICE 키와 겹치는 키값 정의 시 타입에러 발생
type SafeUrlMap = DisallowKeysInServiceOrigin<typeof REAL_CONFIG.URL, SERVICE>

type PublicRuntimeConfig = {
    PROFILE: ValueOf<typeof Phase>
    BASE_PATH: string
    PUBLIC_PATH: string
    PAY_MAIN_URI_BASE: string
    PORT: string
    FE_CDN_ORIGIN: string
    META_TITLE: string
    USE_HTTPS_ORIGIN: boolean
    URL: Readonly<typeof REAL_URL & SafeUrlMap>
} & Omit<typeof REAL_CONFIG, 'URL'>

const CONFIG = getConfig()?.publicRuntimeConfig as PublicRuntimeConfig

export const {PROFILE, BASE_PATH, PUBLIC_PATH, PAY_MAIN_URI_BASE, PORT, FE_CDN_ORIGIN, META_TITLE, USE_HTTPS_ORIGIN} =
    CONFIG || {}

const STATIC_CONFIG = {
    local: LOCAL_CONFIG,
    dev: DEV_CONFIG,
    test: TEST_CONFIG,
    alpha: ALPHA_CONFIG,
    stage: STAGE_CONFIG,
    real: REAL_CONFIG,
}[process.env.PROFILE || 'local']

export const {URL} = CONFIG || STATIC_CONFIG
export default CONFIG
